import React from "react";
import { useSelector } from "react-redux";

const ViewItems = () => {
  const orderId = useSelector((state) => state.EMenu.orderDetails.orderData);
  console.log(orderId)
  const order = useSelector((state) => state.User.order);
  console.log(order)
  const vatRate = useSelector((state) => state.Tax.vatRate);
  const chargeType = useSelector((state) => state.Tax.chargeType);
  const hideTax = useSelector((state) => state.Tax.hideTax);
  const sumOfTax = useSelector((state) => state.Tax.sumOfTax);

  if (!orderId || orderId.length === 0) {
    return <div>No orders found</div>;
  }
// const { orderItems } = previewedOrder
const previewedOrder = orderId[0];
  console.log("Previewed Order:", previewedOrder);

  // Extract orderItems from the order
  const { orderItems } = previewedOrder;

  // If no items, show a "no items" message
  if (orderItems.length === 0) {
    return <div>No items found for this order</div>;
  }


  const inclusiveTotal = order.reduce(
    (sum, item) => sum + Number(item.TotalPrice),
    0
  );
  const exclusiveTotal = order.reduce(
    (sum, item) =>
      sum + (Number(item.TotalPrice) + Number(item.TotalPrice) * sumOfTax),
    0
  );
  const totalPrice = orderItems.reduce(
    (sum, item) => sum + Number(item.TotalPrice),
    0
  );

  

  return (
    <div className="relative w-[90%] md:w-[50%] h-[90%] md:pb-2 m-auto rounded-b-lg bg-white">
      <div className="flex w-full justify-center text-center items-center h-[5vh] md:h-[10vh]">
        <h1 className="text-md font-black">View Your Ordered Items</h1>
      </div>
      <hr className="w-full" />
      <ul className=" min-md:p-4 px-2 flex flex-col gap-4 pt-4 overflow-hidden overflow-y-auto max-sm:h-[50vh] h-[65%] scroll-smooth mb-4">
        {orderItems.length > 0 ? orderItems.map((item, index) => (
          <div key={index} className=" border-primaryLight/70 ">
            <li
              key={index}
              className={` md:w-[100%] md:m-auto md:hover:shadow-xl transition-shadow delay-75 md:border md:border-dark/10 md:hover:border-dark/0 hover:shadow-dark/10 md:p-4 max-md:p-2 flex justify-between md:items-center `}
            >
              <div className="flex flex-col">
                <p className="font-black text-secondary overflow-hidden md:h-full md:w-full mb-1 text-left text-ellipsis text-sm ">
                  {item.ProductName}
                </p>
                <p className="text-sm text-start">
                  {Number(item.Price).toLocaleString("en-NG", {
                    style: "currency",
                    currency: "NGN",
                  })}
                </p>
              </div>
              <div className="grid grid-cols-2 mb-1">
               
                <p className="font-bold text-sm text-start">
                  X {parseInt(item.Quantity)}
                </p>
              </div>
              <div
                className={`${
                  chargeType === "2" && hideTax === "1"
                    ? "grid grid-cols-2 mb-1"
                    : "hidden"
                }`}
              >
                <p className="text-sm text-start">Total Tax</p>
                <p className="font-bold text-sm text-start">
                  X <span className="text-center">{`${vatRate}%`}</span>
                </p>
              </div>
              <p className=" font-black flex text-base">
                {Number(item.TotalPrice).toLocaleString("en-NG", {
                  style: "currency",
                  currency: "NGN",
                })}
              </p>
            </li>
          </div>
        )): <span className="flex justify-center font-bold text-xl">No information found</span> }
      </ul>
      <div className="flex w-full h-[10vh] px-5 ">
        <div className="flex w-full justify-end ">
          <h1 className="text-md font-black text-start w-full">Total: </h1>
          <p className="font-black">
            {" "}
            {totalPrice
              ? totalPrice.toLocaleString("en-NG", {
                  style: "currency",
                  currency: "NGN",
                })
              : 0}
          </p>
        </div>
        {chargeType === "2" && hideTax === "1" ? (
          <div>
            <div className="flex w-full justify-end">
              <h1 className="text-md font-black text-start w-full mr-5">
                Total Tax:{" "}
              </h1>
              <p className="font-black">
                {(totalPrice * sumOfTax).toLocaleString("en-NG", {
                  style: "currency",
                  currency: "NGN",
                })}
              </p>
            </div>
            <hr className="w-full" />
            <div className="flex w-full justify-end bg-secondary">
              <h1 className="text-md font-black text-start w-full">
                Total Price:{" "}
              </h1>
              <p className="font-black">
                {" "}
                {totalPrice
                  ? exclusiveTotal.toLocaleString("en-NG", {
                      style: "currency",
                      currency: "NGN",
                    })
                  : 0}
              </p>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default ViewItems;
